module.exports = __webpack_public_path__ + "static/media/second.a8e9a5be.jpeg";